import { ElLoading } from 'element-plus'

interface LoadingAfter {
  close: () => void
}

interface LoadingOptions {
  fullscreen?: boolean
  background?: string
  svg?: string
  text?: string
  [key: string]: any
}

const loadingList: LoadingAfter[] = []
function startLoading(config?: LoadingOptions) {
  let options = config ? config : {}
  let dft = <LoadingOptions>{ fullscreen: true, background: 'transparent' }
  loadingList.push(ElLoading.service({ ...dft, ...options }) as LoadingAfter)
}

function closeLoading() {
  loadingList.forEach((f) => f.close())
}

function hasLoading(): boolean {
  return loadingList.length > 0
}

class LoadingManager {
  /**
   * 显示加载动画
   * @param config 加载配置选项
   */
  show(config?: LoadingOptions) {
    startLoading(config)
  }

  /**
   * 关闭所有加载动画
   */
  close() {
    closeLoading()
  }

  /**
   * 检查是否有加载动画在显示
   * @returns 是否有加载动画
   */
  hasLoading(): boolean {
    return hasLoading()
  }
}

// 创建单例实例
const loadingManager = new LoadingManager()

// 导出 useLoading 组合式函数
export const useLoading = () => loadingManager
